export const TimeZone = -new Date().getTimezoneOffset() / 60

export function getTimeZoneDiffString (zone?: number){
    if (!zone) return ""

    const diff = zone - TimeZone

    if (diff > 0) {
        return `(+${diff})`;
    } else if (diff < 0) {
        return `(${diff})`;
    } else {
        return "";
    }
}



